import Envelope from '../../src/legacy/Envelope.tsx';
export default Envelope;
